module.exports = __webpack_public_path__ + "static/img/fm12.26c76cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm12.jpg
// module id = ZYpb
// module chunks = 1